import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    content: {
      zIndex: 9,
      height: '100%',
      overflowY: 'scroll',
      padding: 15,
      display: 'flex',
      flexDirection: 'column',
      scrollBehavior: 'smooth',
      '&::-webkit-scrollbar': {
        width: theme.shape.scrollSize,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.scroll,
        borderRadius: theme.shape.scrollRadius,
      },
    },
    loadingSection: {
      display: 'flex',
      justifyContent: 'center',
      padding: 15,
    },
    textCenter: {
      textAlign: 'center',
    },
    itemRoom: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      minHeight: 54,
      paddingLeft: 15,
      paddingRight: 15,
      borderRadius: theme.shape.borderRadius,
      '&:hover': {
        backgroundColor: theme.palette.background.default,
        '& > div': {
          display: 'flex',
        },
      },
    },
    itemButtons: {
      display: 'none',
      justifyContent: 'flex-end',
    },
  }))

export default useStyles
